import React, { useEffect, useRef } from "react";
import * as d3 from 'd3';


export interface ChartDatum{
    label: string;
     value: number;
}

function drawChart(data: ChartDatum[], element: HTMLElement, interpolator: (val: number) => string) {

    const outerRadius = 200
    const innerRadius = 0

    const margin = {
        top: 50, right: 50, bottom: 0, left: 50,
    };

    const width = 2 * outerRadius + margin.left + margin.right;
    const height = 2 * outerRadius + margin.top + margin.bottom;

    const colorScale = d3
        .scaleSequential()
        .interpolator(interpolator)
        .domain([0, data.length]);

    // Remove the old svg
    d3.select(element)
        .select('svg')
        .remove();

    // Create new svg
    const svg = d3
        .select(element)
        .append('svg')
        .attr('width', width)
        .attr('height', height)
        .append('g')
        .attr('transform', `translate(${width / 2}, ${height / 2})`);

    const arcGenerator = d3
        .arc<d3.PieArcDatum<ChartDatum>>()
        .innerRadius(innerRadius)
        .outerRadius(outerRadius);

    const pieGenerator = d3
        .pie<ChartDatum>()
        .padAngle(0)
        .value((d) => d.value);

    const arc = svg
        .selectAll()
        .data(pieGenerator(data))
        .enter();

    // Append arcs
    arc
        .append('path')
        .style('fill', (_, i) => colorScale(i))
        .style('stroke', '#ffffff')
        .style('stroke-width', 0)
        .attr('d', arcGenerator)

    // Append text labels
    arc
        .append('text')
        .attr('text-anchor', 'middle')
        .attr('alignment-baseline', 'middle')
        .text((d) => d.data.label + " - " +  d.data.value)
        .style('fill', '#000000')
        .attr('transform', (d) => {
            const [x, y] = arcGenerator.centroid(d);
            return `translate(${x}, ${y})`;
        });
}

function PieChart(data: ChartDatum[], interpolator: (val: number) => string){
    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (ref.current) {
            drawChart(data, ref.current, interpolator);
        }
    }, [data, ref, interpolator]);


    return <div ref={ref}></div>;
}

export default PieChart;